import React, { useEffect } from "react";
import style from "./UnsuccessfulAction.module.css";

import warningIcon from "../../assets/Images/Icon metro-warning.svg";
import ConnectWithStripeButton from "../../Container/ConnectWithStripeButton/ConnectWithStripeButton";

export const UnsccessfulAction = ({
  title = "Sorry!",
  message = "Action has not been completed successfully",
  description = "",
  buttonTxt = "click",
}) => {
  useEffect(() => {
    console.log("button text:", buttonTxt);
  }, []);

  return (
    <div className={style.contianer}>
      <img className={style.image} src={warningIcon} />
      <div className={style.title}>{title}</div>
      <div className={style.message}>{message}</div>
      <div className={style.description}>{description}</div>      
    </div>
  );
};
